module.exports = __webpack_public_path__ + "img/sciencepage3.54bdc701.png";